// disabling until the component map/children component types can be fleshed out more
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useContext } from 'react';
import { IComponent, IComponentProps, IRendererProps } from '../../interfaces/components/renderer.interface';
import { FormContext } from '../Form/Form';
import { IInitialFormState } from '../../interfaces/components/form.interface';

const rules: Record<string, () => boolean> = {
  requireAfterGrant: () => {
    // pay atention to impact to performance with re-renders
    const context = useContext(FormContext);

    if (!context) {
      return false;
    }

    const { formState }: { formState: IInitialFormState } = context;

    if (
      formState?.vehiclesRequiringAdditionalReqs
      && formState?.vehiclesRequiringAdditionalReqs.length > 0
      && formState?.vehicles
    ) {
      const { vehicles, vehiclesRequiringAdditionalReqs } = formState;
      const selectedVehicles = Object.keys(vehicles).filter((key) => vehicles[key]);
      return selectedVehicles
        .some((vehicleId) => vehiclesRequiringAdditionalReqs.includes(vehicleId));
    }
    return false;
  },
};

const shouldRenderAlternateChildren = (component: IComponent) => {
  const { alternateChildrenRule } = component;
  if (!alternateChildrenRule) {
    return false;
  }

  if (alternateChildrenRule in rules) {
    return rules[alternateChildrenRule]();
  }
  return false;
};

const Renderer = (props: IRendererProps): React.ReactElement => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    componentMap, componentTree = [], setComponentTree,
  } = props;

  return (
    <>
      {componentTree.map((component: IComponent) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const Component: React.FC<IComponentProps> = componentMap[component.componentType];

        return Component ? (
          <Component {...component} key={component.reactKey} setComponentTree={setComponentTree}>
            {component.childrenComponents
              && (
                <Renderer
                  componentTree={
                    shouldRenderAlternateChildren(component)
                      ? component.alternateChildrenComponents
                      : component.childrenComponents
                  }
                  componentMap={componentMap}
                  setComponentTree={setComponentTree}
                />
              )}
          </Component>
        ) : null;
      })}
    </>
  );
};

export default Renderer;
